import React from 'react';
import Button from './Button';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
const SubmitButton = (props) => {
    const { t } = useTranslation();
    const renderLoading = () => (React.createElement(React.Fragment, null,
        React.createElement("span", null, t('button.submitting')),
        React.createElement("span", { className: "form-submit-dot _1" }, "."),
        React.createElement("span", { className: "form-submit-dot _2" }, "."),
        React.createElement("span", { className: "form-submit-dot _3" }, ".")));
    return (React.createElement(Button, { type: "submit", onClick: props.onClick, cls: props.cls, customChildren: true, disabled: props.submitting, className: classNames('form-submit', props.className), fullWidth: props.fullWidth }, props.submitting ? renderLoading() : React.createElement("span", null, props.label)));
};
SubmitButton.defaultProps = {
    cls: ['button--primary'],
};
export default SubmitButton;
